import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useHistory, Redirect, Router, Route } from 'react-router-dom'

import Order from '../containers/Order'
import Cookies from 'js-cookie'
import config from '../config/base'
import axios from 'axios'
import qs from 'qs'
import callApi from '../helpers/callapi'
import jwt from 'jsonwebtoken'
import randomstring from 'randomstring'
import swal from 'sweetalert2'

function useQuery() {
  return new URLSearchParams(useLocation().search)
}

export default function Member() {
  const query = useQuery()
  const dispatch = useDispatch()
  const history = useHistory()

  let baseUrl =
    window.location.protocol +
    '//' +
    window.location.hostname +
    (window.location.port ? ':' + window.location.port : '')

  let redirectUrl = `${baseUrl}/member`
  let clientId = config.lineClientId
  let clientSecret = config.lineClientSecret
  const state = randomstring.generate({ length: 8, charset: 'alphabetic' })
  const scope = 'profile%20openid'
  const nonce = 'kslplusonline9999'

  const getLineToken = async (lineCode) => {
    const reqBody = {
      grant_type: 'authorization_code',
      code: lineCode,
      redirect_uri: redirectUrl,
      client_id: clientId,
      client_secret: clientSecret,
    }
    const reqConfig = {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    }

    try {
      const lineResponse = await axios.post('https://api.line.me/oauth2/v2.1/token', qs.stringify(reqBody), reqConfig)
      // console.log("lineResponse", lineResponse);
      const accessToken = lineResponse.data.access_token
      const decodedIdToken = jwt.verify(lineResponse.data.id_token, clientSecret, {
        algorithms: ['HS256'],
        audience: clientId.toString(),
        issuer: 'https://access.line.me',
        nonce: nonce,
      })
      const res = await axios.get('https://api.line.me/friendship/v1/status', {
        headers: { Authorization: `Bearer ${accessToken}` },
      })
      const lineUser = {
        name: decodedIdToken.name,
        image: decodedIdToken.picture,
        uid: decodedIdToken.sub,
        accessToken,
      }
      console.log(lineUser, 'lineUser')
      return lineUser
    } catch (err) {
      console.log('errGetToken:', err)
      return null
    }
  }

  useEffect(async () => {
    const lineCode = query.get('code')
    const token = query.get('token')
    const accessToken = Cookies.get('accessToken')
    if (lineCode && !accessToken) {
      getLineToken(lineCode)
        .then((data) => {
          if (data) {
            const loginBy = query.get('login') ? 'web+' : 'web'
            loginWithLine(data, loginBy)
          }
          return true
        })
        .catch((err) => console.log(console.log('getLineToken Error: ' + err)))
    }
    const referralEncryptCode = query.get('id')
    // / !me &&
    if (referralEncryptCode) {
      Cookies.set('referral', referralEncryptCode, { expires: 30 })
    }
  }, [])

  const loginWithLine = async (lineUser, loginBy = 'web', params) => {
    try {
      let result
      try {
        result = await callApi({
          url: '/admins/login/line',
          body: lineUser,
        })
        Cookies.set('accessToken', result.accessToken)
        dispatch({ type: 'UPDATE_USER', data: result })
      } catch (err) {
        console.log(err)
        return
      }
    } catch (error) {
      console.log('loginWithLine : ', error)
    }
  }

  return (
    <Route>
      <Order />
      {/* <Redirect to="/order" /> */}
    </Route>
  )
}
